<template>
	<sf-modal-layout size="xl" :title="getMessage_('QWCC001617')" :show="show" :closeModal="close">
		<div class="mb-3">
			<sf-button v-if="isButton_(scrId, 'CU')" line icon="file" :onClick="saveAction">
				<!-- 저장 -->
				{{ getMessage_('QWCC001131') }}
			</sf-button>
		</div>
		<div class="sf-table">
			<table class="qms-table">
				<tbody>
					<tr>
						<!-- 측정기관리번호 -->
						<th>{{ getMessage_('QWCC001317') }}</th>
						<!-- 장비명 -->
						<th>{{ getMessage_('QWCC001314') }}</th>
						<!-- 교정기관코드 -->
						<th>{{ getMessage_('QWCC001579') }}</th>
						<!-- 성적서번호 -->
						<th>{{ getMessage_('QWCC001348') }}(CLICK)</th>
						<!-- 교정완료일 -->
						<th>* {{ getMessage_('QWCC001597') }}</th>
						<!-- 교정결과코드 -->
						<th>* {{ getMessage_('QWCC001345') }}</th>
					</tr>
					<tr>
						<td>{{ saveData.mesEqipNo }}</td>
						<td>{{ saveData.mesEqipNm }}</td>
						<td>
							<sf-select-group labelPosition="left" :inputValue="saveData.calInstCd" :options="calInstCdList" placeholder=" " disabled />
						</td>
						<td>
							<span class="highlighted" @click="copyClipboard">{{ saveData.rslrNo }}</span>
						</td>
						<td>
							<el-date-picker
								format="yyyy-MM-dd"
								value-format="yyyyMMdd"
								:value="saveData.calCmplDd?.replaceAll('-', '')"
								@input="val => changeInput(val, 'calCmplDd')"
							/>
						</td>
						<td>
							<sf-select-group
								labelPosition="left"
								:inputValue="saveData.calRsltCd"
								:options="calRsltCdList"
								:onChange="val => changeInput(val, 'calRsltCd')"
								placeholder=" "
							/>
						</td>
					</tr>
					<tr>
						<!-- 측정범위최대값 -->
						<th>{{ getMessage_('QWCC001598') }}</th>
						<!-- 측정범위최소값 -->
						<th>{{ getMessage_('QWCC001599') }}</th>
						<!-- 측정범위단위코드 -->
						<th>{{ getMessage_('QWCC001909') }}</th>
						<!-- 정밀도최대값 -->
						<th>{{ getMessage_('QWCC001600') }}</th>
						<!-- 정밀도최소값 -->
						<th>{{ getMessage_('QWCC001910') }}</th>
						<!-- 정밀도단위값 -->
						<th>{{ getMessage_('QWCC001601') }}</th>
					</tr>
					<tr>
						<td>{{ Number(saveData.mesScpMaxVal) }}</td>
						<td>{{ Number(saveData.mesScpMinVal) }}</td>
						<td>
							<sf-select-group labelPosition="left" :inputValue="saveData.mesUtmCd" :options="utmCdList" disabled />
						</td>
						<td>{{ Number(saveData.lodeMaxVal) }}</td>
						<td>{{ Number(saveData.lodeMinVal) }}</td>
						<td>
							<sf-select-group labelPosition="left" :inputValue="saveData.lodeUtmCd" :options="utmCdList" disabled />
						</td>
					</tr>
					<tr>
						<!-- 교정비용 -->
						<th>{{ getMessage_('QWCC001347') }}</th>
						<!-- 교정예산 -->
						<th>{{ getMessage_('QWCC001912') }}</th>
						<!-- 성적서 파일 -->
						<th colspan="4">* {{ getMessage_('QWCC001603') }} : {{ getMessage_('QWCC001608') }}</th>
					</tr>
					<tr>
						<td>
							<el-input :value="saveData.calExp" @input="value => inputAmt(value, 'calExp')" />
						</td>
						<td>
							<el-input :value="saveData.calBudg" @input="value => inputAmt(value, 'calBudg')" />
						</td>
						<td colspan="4" class="col-1">
							<template v-if="!!isLoaded && !!saveData.rslrFileId">
								<span class="qms-file-upload">
									<span class="qms-file-upload__item" @click="onDownloadFile">
										<span class="file-upload__item__name">
											{{ `${saveData.rslrNo}.pdf` }}
										</span>
									</span>
									<i class="icon-sf-circle-close" @click="deleteFileAction"></i>
								</span>
							</template>
							<template v-else>
								<file-upload
									id="rslrFileMesCal"
									ref="refFileMesCal"
									width="100%"
									height="100%"
									accept=".pdf"
									@singleFile="fileUpload"
								></file-upload>
							</template>
						</td>
					</tr>
					<tr>
						<!-- 교정내용 -->
						<th colspan="6">{{ getMessage_('QWCC001602') }}</th>
					</tr>
					<tr>
						<td colspan="6">
							<el-input type="textarea" :rows="3" maxlength="65" :show-word-limit="true" v-model="saveData.calSbc" />
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</sf-modal-layout>
</template>

<script>
import * as Yup from 'yup';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import FileUpload from '@qms/Components/FileUpload.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			show: false,
			isLoaded: true,
			saveData: {
				mesEqipNo: '', //측정기관리번호
				mesEqipNm: '', //장비명
				rslrNo: '', //성적서번호
				calInstCd: '', //교정기관코드
				mesScpMaxVal: '', //측정범위최대값
				mesScpMinVal: '', //측정범위최소값
				mesUtmCd: '', //측정범위단위
				lodeMaxVal: '', //정밀도최대값
				lodeMinVal: '', //정밀도최소값
				lodeUtmCd: '', //정밀도단위
				calCmplDd: '', //교정완료일
				calRsltCd: '', //교정결과코드
				calSbc: '', //교정내용
				calExp: 0, //교정비용
				calBudg: 0, //교정예산
				rslrFileId: '', //성적서파일ID
				rslrFile: {} //성적서 파일
			}
		};
	},
	components: { FileUpload },
	computed: {
		...rootComputed,
		...serviceComputed,
		schemaSave() {
			return Yup.object().shape({
				calCmplDd: Yup.date() //교정완료일
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001597')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001597')])),
				calRsltCd: Yup.string() //교정 결과
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001345')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001345')]))
			});
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		refresh() {
			this.$emit('Refresh');
		},
		copyClipboard() {
			//클릭시 성적서 파일 클립보드로 복사하기
			const tempInput = document.createElement('input');
			tempInput.style = 'position: absolute; left: -1000px; top: -1000px';
			tempInput.value = this.saveData.rslrNo;
			document.body.appendChild(tempInput);
			tempInput.select();
			document.execCommand('copy');
			document.body.removeChild(tempInput);
			//{0} 클립보드에 저장했습니다. [성적서 번호]
			this.$sf_toast({ type: 'ok', message: this.$sf_formatString(this.getMessage_('QWCC001914'), [this.getMessage_('QWCC001348')]) });
		},
		changeInput(val, key) {
			try {
				if (key === 'calCmplDd' && this.$moment(val).isAfter(this.$moment())) {
					this.saveData[key] = this.$moment().format('YYYYMMDD');
					// 교정 완료일은 미래 날짜가 될 수 없습니다
					throw new Error(this.$sf_formatString(this.getMessage_('QWCC001781'), [this.getMessage_('QWCC001597')]));
				}
				this.saveData[key] = val;
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message || error });
			}
		},
		inputAmt(val, key) {
			//숫자 길이 16자리, 소수점 2자리로 입력 제한
			val = val.replace(/[^-\.0-9]/g, '');
			const arr = val.toString().split('.');
			if (arr.length > 2) {
				return;
			}
			if (arr.length == 1) {
				if (val.length > 16) {
					val = val.slice(0, 16);
				}
			}
			if (arr.length == 2) {
				if (arr[1].length > 2) {
					arr[1] = arr[1].slice(0, 2);
				}
				if (arr[0].length > 16) {
					arr[0] = arr[0].slice(0, 16);
				}
				arr[1] = '.' + arr[1];
				val = arr.reduce((a, b) => a + b);
			}
			this.saveData[key] = val;
		},
		async onDownloadFile() {
			await this.fileDownload_({ fileId: this.saveData.rslrFileId, fileSeq: 1 });
		},
		fileUpload(value) {
			try {
				if (value?.size > 0) {
					// 파일명이 성적서 번호와 다를 경우
					if (value.name.substring(0, value.name.lastIndexOf('.')) !== this.saveData.rslrNo) {
						this.saveData.rslrFile = {};
						this.$refs.refFileMesCal.deleteFile();
						throw new Error(this.getMessage_('QWCC001608'));
					}
					//파일 양식이 pdf 가 아닐 경우
					if (value.name.substring(value.name.lastIndexOf('.'), value.name.length) !== '.pdf') {
						this.saveData.rslrFile = {};
						this.$refs.refFileMesCal.deleteFile();
						throw new Error(this.getMessage_('QWCC001608'));
					}
					this.saveData.rslrFile = value;
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message || error });
			}
		},
		deleteFileAction() {
			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				title: this.getMessage_('MWCC000108'), //삭제하시겠습니까?
				buttons: [{ title: this.getMessage_('MWCC000107'), clickFn: this.fileDelete }]
			});
		},
		async fileDelete() {
			try {
				this.$sf_toggleLoading(true);
				const { code, messageCd } = await this.deleteFile_({ fileId: this.saveData.rslrFileId, fileSeq: 1 });
				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
				}
				this.saveData.rslrFileId = '';
				this.saveData.rslrFile = {};
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message || error });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		saveAction() {
			try {
				this.schemaSave.validateSync(this.saveData);
				if (!this.isValidFile(this.saveData.rslrFile) && !this.saveData.rslrFileId)
					throw new Error(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001603')]));
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					message: this.getMessage_('QWCC001310'),
					buttons: [{ title: 'Ok', clickFn: this.save }]
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message || error });
			}
		},

		async save() {
			this.$sf_toggleLoading(true);
			try {
				/**멀티 데이터가 포함된 정보를 폼 데이터로 치환 */
				const formData = new FormData();
				for (const [key, val] of Object.entries(this.saveData)) {
					if (!val) continue;
					else formData.set(key, val);
				}

				const response = await this.saveData_(formData);
				if (response?.header?.code == 0) {
					this.$sf_showMessage({
						icon: 'ok',
						message: this.getMessage_(response?.header.messageCd),
						closeFn: this.close
					});
				} else {
					throw new Error();
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001402') });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},

		open(row) {
			this.show = true;
			this.initPopup();
			this.saveData = { ...row };
			this.isLoaded = true;
		},
		close() {
			this.initPopup();
			this.$emit('Refresh');
			this.isLoaded = false;
			this.show = false;
		},
		initPopup() {
			this.$refs.refFileMesCal?.init();
			this.saveData = {
				mesEqipNo: '', //측정기관리번호
				mesEqipNm: '', //장비명
				rslrNo: '', //성적서번호
				calInstCd: '', //교정기관코드
				mesScpMaxVal: '', //측정범위최대값
				mesScpMinVal: '', //측정범위최소값
				lodeMinVal: '', //정밀도최소값
				lodeMaxVal: '', //정밀도최대값
				calCmplDd: '', //교정완료일
				calRsltCd: '', //교정결과코드
				calSbc: '', //교정내용
				rslrFileId: '', //성적서파일ID
				rslrFile: {} //성적서 파일
			};
		},
		/**파일 유무 체크 검증 */
		isValidFile(file) {
			if (!file) return false;
			return file.size > 0 || file.fileSize > 0;
		}
	}
};
</script>
